"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default2 = exports.default = {
  name: 'HeaderPage',
  props: {
    title: {
      type: String,
      default: ''
    },
    titleButton: {
      type: String,
      default: ''
    },
    action: {
      type: Function,
      default: function _default() {}
    }
  }
};